import {Component, EventEmitter, Inject, Input, Output, PLATFORM_ID, SimpleChanges} from '@angular/core';
import {Product} from '../../interface/product';
import {CartCalculationService} from 'src/app/cart/service/cart-calculation.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UntilDestroy} from '@ngneat/until-destroy';
import {JWTService} from "../../../authentication/jwt.service";
import {ToastMessageService} from 'src/app/services/toast-message.service';
import {GlobalService} from 'src/app/services/global.service';
import {isPlatformBrowser} from '@angular/common';
import {BloomsightService} from "../../../bloomsight.service";
import {MatDialog} from "@angular/material/dialog";
import {OutOfStockNotifyDialogComponent} from "../out-of-stock-notify-dialog/out-of-stock-notify-dialog.component";
import {OutOfStockTransmissionService} from "../../../raintree/transmission/out-of-stock-transmission.service";
import {IProductNotifyStock} from "../../interface/product-notify-stock";
import {GtagAPIService} from "@bloomscorp/ngx-gtag";

@UntilDestroy()
@Component({
	selector: 'fb-cart-buttons',
	templateUrl: './cart-buttons.component.html',
	styleUrls: ['./cart-buttons.component.scss']
})
export class CartButtonsComponent {

	constructor(
		private _cartCalculation: CartCalculationService,
		private _activatedROute: ActivatedRoute,
		private _jwt: JWTService,
		private _toast: ToastMessageService,
		private _globalService: GlobalService,
		private _bloomsight: BloomsightService,
		private _router: Router,
		private _dialog: MatDialog,
		private _api: OutOfStockTransmissionService,
		private _gtag: GtagAPIService,
		@Inject(PLATFORM_ID) private _platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	}

	public isBrowser: boolean = false;
	@Output() triggerOpenPreOrder = new EventEmitter();
	@Input() productData: Product = {} as Product;
	@Input() itemInStock: number = 0;
	@Input()
	public addToSwatch: boolean = true;


	public fromDays = 0;
	public toDays = 0;
	public isFabricProduct = true;
	public isUserLoggedIn: boolean = false;
	public nonBulkQty: number = 0;
	public disableAddToCart: boolean = false;
	public isTheOrderInstock = true;
	public isCartDisable: boolean = false;

	private _addOutOfStockNotifyAPI(notify: IProductNotifyStock): void {
		this._api.addOutOfStockNotification(
			notify,
			()=> {},
			()=> {},
			(response)=> {
				if (response.message === '0') {
					this._toast.info(
						"You are already in our waitlist!",
						"We will notify you as soon as the product gets back in stock"
					);
					return;
				}

				this._dialog.open(OutOfStockNotifyDialogComponent, {
					id: 'outOfStockDialog',
					maxWidth: '95vw',
					maxHeight: '90vh',
					data: {
						notificationId: response.message,
						product: this.productData
					}
				});
				localStorage.removeItem(this.productData.sku);
			},
			()=> {},
			()=> {}
		)
	}

	public ngOnInit(): void {
		this.isUserLoggedIn = this._jwt.hasValidJWT();

		if(this.isUserLoggedIn && this.isBrowser){
			let notified: IProductNotifyStock = JSON.parse(localStorage.getItem(this.productData.sku) || "{}");
			if(notified.productId) {
				this._addOutOfStockNotifyAPI(notified)
			}
		}

		if (this.productData.subCategory.madeToOrderProfile) {
			this.fromDays = new Date().setDate((new Date().getDate() + this.productData.subCategory.madeToOrderProfile.deliveryFromDays));
			this.toDays = new Date().setDate(new Date().getDate() + this.productData.subCategory.madeToOrderProfile.deliveryToDays);
		}
		else if (this.productData.madeToOrderProfileEnabled && this.productData.madeToOrderProfile) {
			this.fromDays = new Date().setDate((new Date().getDate() + this.productData.madeToOrderProfile.deliveryFromDays));
			this.toDays = new Date().setDate(new Date().getDate() + this.productData.madeToOrderProfile.deliveryToDays);
		}

		this._activatedROute.params.subscribe(params => {
			if (params['category'] === 'finished-product') {
				this.isFabricProduct = false;
			}
		});

		this._globalService.isTheOrderInstock.subscribe((isTheOrderInstock: boolean): void => {
			this.isTheOrderInstock = isTheOrderInstock;
		});

		this._globalService.disableAddToCart.subscribe((isCartDisable: boolean): void => {
			this.isCartDisable = isCartDisable;
		});

	}

	public addToCartNonBulk(): void {
		this._cartCalculation.swatchProduct = false;
		this._cartCalculation.calculateCart();

		// this._gtag.sendEventData({
		// 	action: 'add_to_cart',
		// 	event: 'add_to_cart',
		// 	send_to: 'G-YY5WPYVGE4',
		// 	ecommerce: {
		// 		items: [{
		// 			item_name: this.productData.name,
		// 			item_id: this.productData.sku,
		// 			price: this._cartCalculation.cartPriceCalculation(),
		// 			item_category: this.productData.category.name,
		// 			quantity: this._cartCalculation.quantity
		// 		}]
		// 	}
		// });

		if (this.productData.sku) {
			this._bloomsight.trackDataEvent(
				'65f033d3fe3931befe4c45f5',
				{sku: this.productData.sku},
				''
			);
		}
	}

	public addToCartSwatch(): void {
		this._cartCalculation.swatchProduct = true;
		this._cartCalculation.quantity = 1;
		this._cartCalculation.calculateCart();

		if(this.productData.sku) {
			this._bloomsight.trackDataEvent(
				'65f0365bfe3931befe4c47ef',
				{sku: this.productData.sku},
				''
			);
		}
	}

	public preOrderTrigger(): void {

		// debugger
		this._cartCalculation.previouslySelectedOrderType = this._cartCalculation.orderType;
		this._cartCalculation.swatchProduct = false;

		if (this.isBrowser) {
			localStorage.setItem('isPreOrderPopupOpen', 'true');
		}

		this.triggerOpenPreOrder.emit();
		this._cartCalculation.orderType = 'PRE_ORDER';
		// debugger
	}

	public ngOnChanges(changes: SimpleChanges): void {

		// if(changes['itemInStock']['currentValue']) {
		this.nonBulkQty = changes['itemInStock']['currentValue']
		// }
	}

	public loginToAddCart(): void {
		if (this.isBrowser) {
			localStorage.setItem("storeUrl", window.location.href);
		}
		this._router.navigate(['auth']).then(() => {
		});
	}

	public loginToGetNotified(): void {
		if(this.isBrowser)
			localStorage.setItem("storeUrl", window.location.href);

		this._router.navigate(['auth']).then(() => {
			if (this.isBrowser) {
				let notify = {
					productId: this.productData.id,
					madeToOrderProductId: (
						this.productData.madeToOrderProfileEnabled &&
						this.productData.fabricProfile?.fabricProfileItemList &&
						this._cartCalculation.selectedFabricItem
					)?
						this._cartCalculation.selectedFabricItem.id: 0,
					sizeOptionId: (this.productData.productSizeProfileList && this._cartCalculation.selectedSize)? this._cartCalculation.selectedSize.id : 0,
					status: "PENDING"
				}
				localStorage.setItem(this.productData.sku, JSON.stringify(notify));
			}
		})


	}

	public notifyOutOfStock() {
		let notify = {
			productId: this.productData.id,
			madeToOrderProductId: (
				this.productData.madeToOrderProfile &&
				this.productData.fabricProfile?.fabricProfileItemList &&
				this._cartCalculation.selectedFabricItem
			)?
				this._cartCalculation.selectedFabricItem.id: 0,
			sizeOptionId: (this.productData.productSizeProfileList && this._cartCalculation.selectedSize)? this._cartCalculation.selectedSize.id : 0,
			status: "PENDING"
		}

		this._addOutOfStockNotifyAPI(notify);
	}
}
